export const blockIconsSocialGroupsNew = (
	<span className='material-symbols-outlined'>groups</span>
);
